import React, { useState, useContext } from 'react'
import {AppContext} from '../context/AppContext'
import styled from 'styled-components'
import LessonLink from './LessonLink'

export default function CourseUnits({ units }) {
  const [selectedUnit, setSelectedUnit] = useState(null)
  const {appState} = useContext(AppContext)
  return (
    <CourseUnitsWrapper className="units-wrapper">
      <ul className={`units ${appState.isLessonsLocked && 'lessons-locked'}`}>
        {units.map((unit) => {
          return (
            <li key={unit.key} className='unit'>
              <h3 className='unit-title' onClick={() => setSelectedUnit(unit.key)}>{unit.unit_name}</h3>
              {selectedUnit === unit.key && (
                <div className="unit-content">
                  <ul className='unit-lessons'>
                    {unit.lessons.map((lesson) => {
                      return (
                        <li key={lesson.slug} className='lesson'>
                          {appState.isCoursePurchased ? (
                            <LessonLink lesson={lesson} unit={unit} />
                          ) : lesson.title}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </CourseUnitsWrapper>
  )
}

const CourseUnitsWrapper = styled.div`
  background: var(--dark-backgrorund);
`